import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import { copyToClipboard, trimAddress } from "../../utils/helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";
import { BASE_URL, STANDARD_IMAGE_URL } from "../../utils/constant";
import { Icon } from "@iconify/react/dist/iconify.js";

const NftMarketplaceViewLayer = () => {
     const [loading, setLoading] = useState(false);
     const [data, setData] = useState(null);
     const { id } = useParams();
     const { AsyncGetApiCall } = useApi();

     const fetchMarketplace = async () => {
          setLoading(true);
          try {
               const result = await AsyncGetApiCall(`/market-place/view-in-admin?id=${id}`);
               console.log("result: ", result);

               if (result.errors) {
                    toast.error(result.errors[0]);
               } else if (result.success) {
                    setData(result?.data);
               }
          } catch (error) {
               toast.error("An error occurred while fetching Marketplace details");
          }
          setLoading(false);
     };

     useEffect(() => {
          fetchMarketplace();
     }, []);

     return (
          <>
               {loading && <Loader />}
               <div className="row gy-4">
                    {/* Left Card - NFT Image */}
                    <div className="col-lg-4">
                         <div className="card position-relative border radius-16 overflow-hidden bg-base h-100">
                              <img
                                   src={data?.image ? `${BASE_URL}/uploads/${data?.image}` : STANDARD_IMAGE_URL}
                                   alt="Marketplace"
                                   className="w-100 object-fit-cover"
                                   style={{ height: "100%", minHeight: "400px" }}
                              />
                         </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-lg-6">
                         {/* Top Right Card - NFT Data */}
                         <div className="card mb-10">
                              <div className="card-body p-24">
                                   <h5 className="mb-16">Marketplace Details</h5>
                                   <ul>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Marketplace Id</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {trimAddress(data?._id, 10, 8)}
                                                  <button
                                                       onClick={() => copyToClipboard(data?._id)}
                                                       className="ms-3 p-0 border-0 bg-transparent"
                                                       style={{ lineHeight: 1 }}
                                                  >
                                                       <IoCopyOutline />
                                                  </button>
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Nft Id</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {trimAddress(data?.nftId, 10, 8)}
                                                  <button
                                                       onClick={() => copyToClipboard(data?.nftId)}
                                                       className="ms-3 p-0 border-0 bg-transparent"
                                                       style={{ lineHeight: 1 }}
                                                  >
                                                       <IoCopyOutline />
                                                  </button>
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Collection Id</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {trimAddress(data?.collectionId, 10, 8)}
                                                  <button
                                                       onClick={() => copyToClipboard(data?.collectionId)}
                                                       className="ms-3 p-0 border-0 bg-transparent"
                                                       style={{ lineHeight: 1 }}
                                                  >
                                                       <IoCopyOutline />
                                                  </button>
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Method</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.method || "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Category</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.category || "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Date</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.createdAt ?
                                                       new Date(data?.createdAt).toLocaleString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: true,
                                                       })
                                                       : 'N/A'}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Expiry</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.fixedDetails?.expiry ?
                                                       new Date(data?.fixedDetails?.expiry).toLocaleString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: true,
                                                       })
                                                       : 'N/A'}
                                             </span>
                                        </li>

                                   </ul>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
};

export default NftMarketplaceViewLayer;